import React, {useEffect, useRef} from 'react';
import * as PIXI from 'pixi.js';
import {t4} from './DrawingDataType';
import {Config} from "../models/Config";
import {Guide} from "./Guide";

type P = {
    data: t4,
    size?: number
};

let app: PIXI.Application;

export const ReadonlyCanvas2 = (props: P) => {

    // ref

    const containerElementRef = useRef(null);

    //

    useEffect(() => {

        const size = props.size || Config.defaultSize;

        app = app || new PIXI.Application({
            backgroundColor: Config.backgroundColor,
            width: size,
            height: size,
            preserveDrawingBuffer: true
        });

        const scale = size / Config.defaultSize;

        const container = new PIXI.Container();
        app.stage.addChild(container);

        const g2 = new PIXI.Graphics();
        g2.beginFill(0xffffff);
        g2.drawRect(0, 0, size, size);
        container.addChild(g2);

        let timeoutId: number;
        let intervalId: number;

        const faceGuideSprite = new Guide(props.data.guide, () => {
            faceGuideSprite.scale.set(scale * .5);
            faceGuideSprite.position.set(
                (Config.defaultSize - 930 / 2) / 2 * scale,
                (Config.defaultSize - 1026 / 2) / 2 * scale
            );
            container.addChild(faceGuideSprite);

            const containerElement = containerElementRef.current;
            // (containerElement as any).appendChild(app.view);

            timeoutId = window.setTimeout(() => {
                const imgUrls: string[] = [];

                const data = props.data;
                for (let i of data.paths) {
                    const color = i.color;
                    const width = i.width || 2;
                    const points = i.points;
                    const p = points[0];
                    const a = (value: number) => {
                        return value * (size / Config.defaultSize);
                    };

                    const g = new PIXI.Graphics();
                    container.addChild(g);

                    g.lineStyle(a(width * 6), color)
                        .moveTo(a(p.position.x), a(p.position.y));

                    for (let j = 1; j < points.length; j++) {
                        const p = points[j];
                        const ax = a(p.position.x);
                        const ay = a(p.position.y);
                        if (ax < 0 || size < ax || ay < 0 || size < ay) continue;
                        g.lineTo(a(p.position.x), a(p.position.y));
                    }
                }

                const imgUrl = app.renderer.extract.base64(container);
                imgUrls.push(imgUrl);

                const img = document.createElement('img');
                img.width = size;
                img.height = size;
                img.style.background = 'white';
                if (!containerElement) return;
                (containerElement as any).appendChild(img);

                img.src = imgUrls[0];

                app.stage.removeChild(container);

            }, 200);

        });

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);

            const containerElement = containerElementRef.current;
            (containerElement as any).innerHTML = '';
        };

    }, [props.data,props.size]);

    // render

    return (
        <div ref={containerElementRef}/>
    );
};